import React from 'react';
import clsx from 'clsx';
import Link from '@components/atoms/link/link';
import useProductQuery from '@hooks/product/use-product-query';
import styles from './product-main-heading.module.scss';

const shouldDisplayColor = (localizedColorName: string, colorName: string): boolean => {
  if (localizedColorName) {
    return false;
  }
  return !['Other', 'Autre', 'Andere', 'Altro', 'Otro'].includes(colorName);
};

const ProductMainHeading: React.FC = () => {
  const { product } = useProductQuery();
  const isColorDisplayed = shouldDisplayColor(product.color?.localizedName, product.color?.name);

  return (
    <h1 className={styles.productTitle}>
      <span
        className={styles.productTitle__name}
        data-cy="productTitle_name"
      >
        {product.name}
        {isColorDisplayed && <> - {product.color?.localizedName} </>}
      </span>

      <span
        className={clsx('vc-title-l', styles.productTitle__brand)}
        data-cy="productTitle_brand"
      >
        {product.brand?.url?.path && (
          <Link
            className={styles.productTitle__brand__link}
            href={product.brand?.url.path}
          >
            {product.brand?.name}
          </Link>
        )}
        {!product.brand?.url?.path && <span>{product.brand?.name}</span>}
      </span>
    </h1>
  );
};

export default ProductMainHeading;
